const REQUEST = 'REQUEST'
const SUCCESS = 'SUCCESS'
const FAILURE = 'FAILURE'

export default {
	REQUEST,
	SUCCESS,
	FAILURE
}
